<template>
  <div class="menu-list-container">
    <template v-for="item in navigationItems" :key="item.id">
      <bookmark-tourtip
        v-if="item.destination === 'bookmarks' && showBookmarkTourtip(4)"
        :classes="classes"
        :sequence="4"
        :delay="300"
      >
        <menu-item
          :active="item.id === active.id"
          :mobile="mobile"
          :on-tour="onTour"
          :navigation-item="item"
        />
      </bookmark-tourtip>
      <menu-item
        v-else
        :active="item.id === active.id"
        :mobile="mobile"
        :on-tour="onTour"
        :navigation-item="item"
      />
    </template>
  </div>
</template>

<script>
import BookmarkTourtip from '@components/tour/bookmarks/bookmarkTourtip';
import MenuItem from '@components/ui/menu/item';

import GlobalMixin from '@/mixins/global';

export default {
  components: { BookmarkTourtip, MenuItem },
  mixins: [GlobalMixin],
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    navigationItems: {
      type: Array,
      default: () => [],
    },
    onTour: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    active() {
      // if route has no ties to web-main group, don't do anything
      // secondaryRoute on meta just means it doesn't live in main content
      if (this.$route.meta.secondaryRoute) return {};
      // see if one of the items matches query directly first
      const queryItem = this.navigationItems.find(ni => ni.matchesRouteQuery(this.$route));
      if (queryItem) return queryItem;

      // otherwise see if last visited dashboard has a matching menu item
      const lastDashboardId = this.$store.getters['dashboards/lastVisitedId'];
      const dashboardItemMatch = this.navigationItems.find(ni => {
        return ni.destination === 'dashboard' && lastDashboardId.includes(ni.resourceId);
      });

      if (dashboardItemMatch) return dashboardItemMatch;

      // otherwise see if there's a home menu item that matches the last dashboard item
      const homeDashboard = this.$store.getters['dashboards/menuDefaultDashboard'];
        if (homeDashboard) {
        const homeItemMatch = this.navigationItems.find(ni => {
          return ni.destination === 'dashboard' && ni.resourceId === homeDashboard.id;
        });

        if (homeItemMatch) return homeItemMatch;
      }

      // lastly see if there's a home item and our path is /
      if (this.$route.path === '/') {
        const homeItemPathMatch = this.navigationItems.find(ni => {
          return ni.destination === 'home';
        });

        if (homeItemPathMatch) return homeItemPathMatch;
      }

      return {};
    },
    classes() {
      if (this.mobile) {
        return ['mobile-menu-popover'];
      }
    },
  },
  methods: {
    showBookmarkTourtip(sequence) {
      return this.onTour && sequence === this.$store.getters['session/tourSequence'];
    },
  },
};
</script>
